import { render, staticRenderFns } from "./NavigableTabs.vue?vue&type=template&id=74ba2893&"
import script from "./NavigableTabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./NavigableTabs.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports